import { keepPreviousData, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { message } from "antd";
import { ACCOUNT_QUERY_KEY } from "./accounts.constants";

import { addAccount, getAccounts, removeAccount, updateAccount } from "../../services/accountsApi";

const invalidateAccounts = async (queryClient) => {
  await queryClient.invalidateQueries({ queryKey: ACCOUNT_QUERY_KEY });
};

export const useAccountsQuery = (page, pageSize) =>
  useQuery({
    queryKey: [...ACCOUNT_QUERY_KEY, page, pageSize],
    queryFn: () => getAccounts({ page, pageSize }),
    staleTime: 30_000,
    gcTime: 5 * 60_000,
    placeholderData: keepPreviousData,
    retry: false,
    select: (data) => data,
  });

export const useAddAccountMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload) => addAccount(payload),
    onSuccess: async (successMessage) => {
      message.success(successMessage);
      await invalidateAccounts(queryClient);
    },
  });
};

export const useUpdateAccountMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ accountId, payload }) =>
      updateAccount(accountId, payload),
    onSuccess: async (successMessage) => {
      message.success(successMessage);
      await invalidateAccounts(queryClient);
    },
  });
};

export const useDeleteAccountMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (accountId) => removeAccount(accountId),
    onSuccess: async (successMessage) => {
      message.success(successMessage);
      await invalidateAccounts(queryClient);
    },
  });
};
